function setWidth(el, val) {
  if (typeof val === "function") val = val();
  if (typeof val === "string") el.style.width = val;
  else el.style.width = val + "px";
}


export default class SingleHero {
  constructor() {
    this.selector = '.b-single-hero';
    this.sliders = [];
  }

  // eslint-disable-next-line class-methods-use-this
  bootstrap() {
    const blocks = document.querySelectorAll(this.selector);
    blocks.forEach(block => {
      this.positionCurtain(block);

      window.addEventListener('resize', () => {
        this.positionCurtain(block);
      });
    });


  }

  positionCurtain(block) {
    const curtain = block.querySelector('.b-single-hero__curtain');
    const colShare = block.querySelector('.b-single-hero__col--share');
    const xCoor = colShare.getBoundingClientRect().left;
    const curtainWidth = window.innerWidth - xCoor;
    setWidth(curtain, curtainWidth);
  }
}
